export function NotFoundView() {
  return <div>Not Found View</div>;
}
